<template>
  <Dialog
    v-model:visible="localVisible"
    modal
    :header="headerMsg"
    :style="{ width: '25rem' }"
    :closable="false"
  >
    <div class="flex items-center gap-4">
      <i
        class="pi pi-exclamation-triangle !text-3xl"
        v-if="showHazardIcon"
      />
      <!-- Use v-html to render HTML content in the message -->
      <span
        v-if="message"
        v-html="message"
      />
    </div>
    <template #footer>
      <Button
        label="No"
        icon="pi pi-times"
        text
        @click="cancelAction"
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        @click="confirmAction"
      />
    </template>
  </Dialog>
</template>

<script>
  import { defineComponent, ref, watch } from "vue";

  export default defineComponent({
    name: "ConfirmationDialog",
    props: {
      visible: {
        type: Boolean,
        required: true
      },
      message: {
        type: String,
        required: true
      },
      headerMsg: {
        type: String,
        default: "Confirm"
      },
      onConfirm: {
        type: Function,
        required: true
      },
      onCancel: {
        type: Function,
        required: false
      },
      showHazardIcon: {
        type: Boolean,
        default: true
      }
    },
    emits: ["update:visible", "confirm"],
    setup(props, { emit }) {
      const localVisible = ref(props.visible);

      // Watch the visible prop and update localVisible accordingly
      watch(
        () => props.visible,
        (newVal) => {
          localVisible.value = newVal;
        }
      );

      // Watch localVisible and emit changes to the parent
      watch(
        () => localVisible.value,
        (newVal) => {
          emit("update:visible", newVal);
        }
      );

      const closeDialog = () => {
        localVisible.value = false;
      };

      const confirmAction = () => {
        if (props.onConfirm) {
          props.onConfirm();
        }
        closeDialog();
      };

      const cancelAction = () => {
        if (props.onCancel) props.onCancel();
        closeDialog();
      };

      return {
        localVisible,
        cancelAction,
        confirmAction
      };
    }
  });
</script>
